class Timer {
  private timerId: NodeJS.Timeout | null;
  private startTime: number;
  private remaining: number;
  private callback: () => void;

  constructor(callback: () => void, delay: number) {
    this.timerId = null;
    this.startTime = 0;
    this.remaining = delay;

    this.callback = () => {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      callback();
    };
  }

  public resume() {
    if (
      !this.timerId &&
      this.remaining >= 0 &&
      this.remaining !== Number.POSITIVE_INFINITY
    ) {
      this.startTime = Date.now();
      this.timerId = setTimeout(this.callback, this.remaining);
    }
  }

  public pause() {
    if (this.timerId && this.remaining !== Number.POSITIVE_INFINITY) {
      clearTimeout(this.timerId);
      this.timerId = null;
      const diff = Date.now() - this.startTime;
      this.remaining -= diff;
    }
  }
}

const createTimer = (callback: () => void, delay: number) =>
  new Timer(callback, delay);

export { Timer, createTimer };
